import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ShowInfoAfspraakInWacht from "../Componenten/Calender/ShowInfoAfspraakInWacht";
import { getUserdetails } from "../Localstorage/localstorage";
import SelectAdmins from "../Componenten/SelectAdmins";

const BannerPlannig = ({
  bannerName = "Dashboard",
  Changeview,
  setSelected,
  selected,
  index,
  views,
}) => {
  const userdetails = getUserdetails();
  const [activeTab, setactiveTab] = useState(views[index].name)
  const { appointmentsInWacht } = useSelector((state) => state.appointment);

  useEffect(() => {
    const name = views[index]?.name;
    if (name) setactiveTab(name);
  }, [index, views]);

  const NewView = (item) => {
    Changeview(item.id)
    setactiveTab(item.name);

  }

  const [open, setOpen] = useState();
  return (
    <div className="mt-4 mx-4 items-center sm:mx-8">
      <div className="flex w-full flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
        {userdetails.role_id == 1 && (
          <div className="w-full min-w-0 max-w-md shrink-0">
            <SelectAdmins
              label={false}
              selected={selected}
              setSelected={setSelected}
            />
          </div>
        )}
        <div className="min-w-0 flex-1 overflow-x-auto rounded-lg border border-wa-border bg-wa-panel2 p-1 lg:overflow-visible">
          <div className="inline-flex min-w-max gap-1 lg:flex lg:min-w-0 lg:justify-end">
            {views.length > 0 &&
              views.map((item, id) => (
                <button
                  key={id}
                  type="button"
                  onClick={() => NewView(item)}
                  className={
                    activeTab === item.name
                      ? "whitespace-nowrap rounded-md bg-wa-accent px-3 py-1.5 text-sm font-medium text-wa-onaccent shadow-sm"
                      : "whitespace-nowrap rounded-md px-3 py-1.5 text-sm text-wa-muted transition hover:bg-wa-hover hover:text-wa-text"
                  }
                >
                  {item?.name}
                </button>
              ))}
          </div>
        </div>
      </div>
      <ShowInfoAfspraakInWacht
        evenments={appointmentsInWacht}
        selected={selected}
        user={userdetails}
        open={open}
        setOpen={setOpen}
      />
    </div>
  );
};

export default BannerPlannig;
